import { FadeIn } from "@/components/Reveal";
import ChapterHeader from "@/components/ChapterHeader";
import UploadedPhotos from "@/components/UploadedPhotos";
import { useCategoryPhotos, pickPhoto } from "@/lib/usePhotos";

export default function Orchard() {
  const orchardPhotos = useCategoryPhotos("orchard");
  const img1 = pickPhoto(orchardPhotos, 0);
  const img2 = pickPhoto(orchardPhotos, 1);
  const img3 = pickPhoto(orchardPhotos, 2);
  return (
    <main data-testid="orchard-page" className="pt-32 pb-24">
      <section className="mx-auto max-w-[1600px] px-6 lg:px-12">
        <FadeIn>
          <div className="stamp mb-8">Vol · V · The Land</div>
          <h1 className="font-display text-6xl md:text-8xl leading-[0.95] text-[#F2E7D0] max-w-5xl">
            Mango. Lychee. <em className="italic text-[#D97645]">Sal</em>.
          </h1>
          <p className="mt-8 max-w-xl text-[#B8A891] text-lg">
            The estate is embedded in a mango and lychee orchard, ringed by mature pine, fir,
            eucalyptus and sal — and folds into a private Sal forest at its edge.
          </p>
        </FadeIn>
      </section>

      <section className="mx-auto max-w-[1600px] px-6 lg:px-12 py-24 grid grid-cols-1 lg:grid-cols-12 gap-6">
        <FadeIn className="lg:col-span-7">
          <div className="w-full aspect-[4/5] bg-[#27221C] overflow-hidden">
            {img1 && <img src={img1} alt="Mango orchard" className="w-full h-full object-cover vintage-img" />}
          </div>
        </FadeIn>
        <FadeIn delay={0.15} className="lg:col-span-5 grid grid-cols-1 gap-6 content-start">
          <div className="w-full aspect-[4/3] bg-[#27221C] overflow-hidden">
            {img2 && <img src={img2} alt="Sal forest" className="w-full h-full object-cover vintage-img" />}
          </div>
          <div className="w-full aspect-[4/3] bg-[#27221C] overflow-hidden">
            {img3 && <img src={img3} alt="Fresh produce" className="w-full h-full object-cover vintage-img" />}
          </div>
        </FadeIn>
      </section>

      <section className="mx-auto max-w-[1600px] px-6 lg:px-12 py-16">
        <ChapterHeader num="01" kicker="Trees on the estate" title="A canopy grown decades before the guests arrived." />
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
          {["Mango", "Lychee", "Pine", "Fir", "Eucalyptus", "Sal", "Guava", "Jamun"].map((t, i) => (
            <FadeIn key={t} delay={i * 0.04}>
              <div className="border border-white/10 p-6">
                <div className="chapter-num">Species · {String(i+1).padStart(2,"0")}</div>
                <div className="font-display text-3xl mt-2 text-[#F2E7D0]">{t}</div>
              </div>
            </FadeIn>
          ))}
        </div>
      </section>

      <UploadedPhotos category="orchard" kicker="On The Land" title="The estate through the seasons." />
    </main>
  );
}
